import { Chip } from "@/components/ui";
import type { PublicChip } from "@/lib/api/types";

/** Step 1: good points (required, capped) and bad points (optional, capped). */
export function StepChips({
  goodChips,
  badChips,
  good,
  bad,
  goodMax,
  badMax,
  onToggleGood,
  onToggleBad,
}: {
  goodChips: PublicChip[];
  badChips: PublicChip[];
  good: string[];
  bad: string[];
  goodMax: number;
  badMax: number;
  onToggleGood: (id: string) => void;
  onToggleBad: (id: string) => void;
}) {
  return (
    <div className="mt-4 flex flex-col gap-8">
      <fieldset>
        <legend className="text-label-neutral">
          {goodMax}개까지 골라 주세요. 지금 {good.length}개 골랐어요.
        </legend>
        <ChipGrid chips={goodChips} selected={good} onToggle={onToggleGood} />
      </fieldset>
      {badChips.length > 0 ? (
        <fieldset>
          <legend className="wds-headline-1 text-label-normal">아쉬웠던 점도 있었나요?</legend>
          <p className="mt-1 text-label-neutral">
            골라도 되고 건너뛰어도 돼요. 고르시면 초안에 그대로 들어가요. {badMax}개까지예요.
          </p>
          <ChipGrid chips={badChips} selected={bad} onToggle={onToggleBad} />
        </fieldset>
      ) : null}
    </div>
  );
}

function ChipGrid({
  chips,
  selected,
  onToggle,
}: {
  chips: PublicChip[];
  selected: string[];
  onToggle: (id: string) => void;
}) {
  return (
    <ul className="mt-3 flex flex-wrap gap-2">
      {chips.map((c) => (
        <li key={c.id} className="max-w-full">
          <Chip
            size="xlarge"
            active={selected.includes(c.id)}
            onClick={() => onToggle(c.id)}
            style={{ whiteSpace: "normal", textAlign: "left", maxWidth: "100%" }}
          >
            {c.label}
          </Chip>
        </li>
      ))}
    </ul>
  );
}
